// src/pages/StudyGuide/index.jsx
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';
import { getConfig } from '@edx/frontend-platform';
import './StudyGuide.scss';

const BADGE_CLASS_MAP = {
  courses: 'course-number',
  labs: 'lab-indicator',
  live: 'live-indicator',
  assessment: 'assessment-indicator',
};

const GRID_CLASS_MAP = {
  courses: 'course-grid',
  labs: 'labs-grid',
  live: 'live-grid',
  assessment: 'assessment-grid',
};

const CARD_CLASS_MAP = {
  courses: 'courses-card',
  labs: 'lab-card',
  live: 'live-card',
  assessment: 'assessment-card',
};

export default function StudyGuide() {
  const { slug } = useParams();
  const [guide, setGuide] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    getAuthenticatedHttpClient()
      .get(`${getConfig().LMS_BASE_URL}/alnafi/study-guides/${slug}/`)
      .then(({ data }) => { if (isMounted) setGuide(data); })
      .catch(() => { if (isMounted) setError(true); });
    return () => { isMounted = false; };
  }, [slug]);

  if (error) return <div className="study-guide-container">Study guide not found.</div>;
  if (!guide) return <div className="study-guide-container">Loading...</div>;

  return (
    <div className="study-guide-container">
      <div className="header-section animated-fade-in">
        <div className="main-title">
          <h1 className="title-text">{guide.title}</h1>
        </div>
      </div>

      {guide.content.map((section) => (
        <div className="content-section animated-slide-up" key={section.title}>
          <h2 className="section-title">{section.title}</h2>
          <div className={GRID_CLASS_MAP[section.section_type]}>
            {section.items.map((item) => (
              <div className={`${CARD_CLASS_MAP[section.section_type]} hover-lift`} key={item.title}>
                {item.badge ? (
                  <div className={BADGE_CLASS_MAP[section.section_type]}>{item.badge}</div>
                ) : (
                  section.section_type === 'assessment' && <div className="assessment-indicator" />
                )}
                <h3>{item.title}</h3>
                <p className="course-description">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}